export const PLATFORM = {
  WEB: 'web',
  APP: 'app',
} as const;

export type Platform = (typeof PLATFORM)[keyof typeof PLATFORM];
